import Swiper from 'swiper'

window.addEventListener('DOMContentLoaded', () => {
  const thumbSlider = document.getElementById('hospital_carousel')
  const thumbCount = thumbSlider.children[0].children.length
  let loopSetting
  if (thumbCount > 3) {
    loopSetting = true
  } else {
    loopSetting = false
  }
  const sliderThumbnail = new Swiper (thumbSlider, {
    'slidesPerView': 3,
    'loopedSlides': 3,
    'loop': loopSetting,
    'freeMode': true,
    'spaceBetween': 10,
    'loopAdditionalSlides': 1,
    'watchSlidesVisibility': true,
    'watchSlidesProgress': true,
    'slideToClickedSlide': true,
    'autoplay': {
      'delay': 5000,
    },
    'controller': {
      'control': swiper
    }
  })
  const swiper = new Swiper ('#hospital_slider', {
    'loop': true,
    'slidesPerView': 1,
    'spaceBetween': 25,
    'navigation': {
      'nextEl': '#hospital_slider .swiper-button-next',
      'prevEl': '#hospital_slider .swiper-button-prev'
    },
    'thumbs': {
      'swiper': sliderThumbnail
    },
    'breakpoints': {
      767: {
        'thumbs': {
          'swiper': ''
        }
      }
    },
    'watchOverflow': true,
  })
  if (window.innerWidth > 767) {
    const topSwiper = new Swiper('#mv-swiper-pc', {
      'loop': true,
      'slidesPerView': 1,
      'autoplay': {
        delay: 5000
      },
      'watchOverflow': true,
    })
  } else {
    const topSwiper = new Swiper('#mv-swiper-sp', {
      'loop': true,
      'slidesPerView': 1,
      'autoplay': {
        delay: 5000
      },
      'watchOverflow': true,
    })
  }
  const hospital_thumb_swiper = new Swiper ('.hospital_thumb_swiper', {
    'loop': true,
    'slidesPerView': 1,
    'spaceBetween': 25,
    'pagination': {
      'el': '.swiper-pagination',
      'type': 'bullets',
      'clickable': true,
    },
  })
})
